import { buildPaginatedListStore } from "./utils/storeBuilders";

export const useInterventionToPlanListStore = buildPaginatedListStore(
  "interventionToPlanList",
  "/interventions/to_plan/",
  "Aucune intervention à plannifier trouvée",
  true,
);
